// extracted by mini-css-extract-plugin
export default {"wrapper":"calc_wrapper__zzJTI"};